var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgButtonPlayRound = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 92,
  height: 92,
  fill: "none",
  viewBox: "0 0 92 92"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("rect", {
  width: 92,
  height: 92,
  fill: "#fff",
  rx: 46
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M62.282 43.75c1.647 1.047 1.647 3.451 0 4.5l-21.7 13.808c-1.775 1.13-4.098-.145-4.098-2.25V32.191c0-2.105 2.323-3.38 4.099-2.25z"
}))));
export { SvgButtonPlayRound as ReactComponent };